import { render } from "@wordpress/element";
import { Block } from "./block/block";

const selector = ".wp-block-steam-blocks-vacancies";

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(selector);

	if (element) {
		const attributes = { ...element.dataset };

		render(
			<Block
				{...attributes}
				text={({ label }) => {
					const text = JSON.parse(attributes.text);

					return (
						<span dangerouslySetInnerHTML={{ __html: text[label] ?? "" }} />
					);
				}}
			/>,

			element,
		);
	}
});
